import { HttpClient } from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {ActionResult, ActionResultList, RaceSettings} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({providedIn: 'root'})
export class RaceSettingsService {
  public static readonly BLOCK_RACE_EDIT_NOT_ALLOWED: number = 10;
  public static readonly START_BY_TYPE_EDIT_NOT_ALLOWED: number = 11;
  public static readonly RESULT_PROCESSING_TYPE_EDIT_NOT_ALLOWED: number = 12;
  public static readonly MINIMUM_LAP_DURATION_EDIT_NOT_ALLOWED: number = 13;
  public static readonly LAP_LENGTH_EDIT_NOT_ALLOWED: number = 14;
  public static readonly MAX_LAPS_COUNT_EDIT_NOT_ALLOWED: number = 15;
  public static readonly TEAM_RACE_TYPE_EDIT_NOT_ALLOWED: number = 16;

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
  }

  fetchRaceSettings = (raceId?: number): Observable<RaceSettings | null> =>
    this.http.post<ActionResult<RaceSettings>>(this.environmentService.getApiUrl() + "/api/public/racesettings/getbyraceid", raceId)
      .pipe(map(value => value?.result ?? null));

  fetchRaceSettingsByEventId = (eventId: number | undefined, isAdmin: boolean): Observable<RaceSettings[]> => {
      const basePath = isAdmin ? '' : 'public/';
      const url = `${this.environmentService.getApiUrl()}/api/${basePath}racesettings/getbyeventid?eventId=${eventId}`;

      return this.http.get<ActionResultList<RaceSettings[], number>>(url)
          .pipe(map(value => value?.result ?? []));
  }

  updateRaceSettings = (settings: RaceSettings, onSuccess: () => void, onError: (resultCode: number | undefined) => void): void => {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/racesettings/update", settings)
      .subscribe(actionResult => {
        const code = actionResult.resultCode;
        if (code === -1 || code === RaceSettingsService.BLOCK_RACE_EDIT_NOT_ALLOWED ||
            code === RaceSettingsService.START_BY_TYPE_EDIT_NOT_ALLOWED ||
            code === RaceSettingsService.RESULT_PROCESSING_TYPE_EDIT_NOT_ALLOWED ||
            code === RaceSettingsService.MINIMUM_LAP_DURATION_EDIT_NOT_ALLOWED ||
            code === RaceSettingsService.LAP_LENGTH_EDIT_NOT_ALLOWED||
            code === RaceSettingsService.TEAM_RACE_TYPE_EDIT_NOT_ALLOWED||
            code === RaceSettingsService.MAX_LAPS_COUNT_EDIT_NOT_ALLOWED) {
          onError(code);
        } else {
          onSuccess();
        }
      });
  }
}
